<template>
  <div>
    <page-header></page-header>
    <div v-loading.fullscreen.lock="loading" class="device-list">
      <div @click="intoDevice(index)" class="device-item" v-for="(item,index) in deviceList" :key="item.device_id.$oid">
        <el-card class="box-card">
          <div class="clearfix card-heard">
            <span style="line-height: 36px;">{{item.name}}</span>
          </div>
          <div class="device-info">
            <div>
              <p>
                <span class="s-label">DTU号</span>
                <span>{{item.device_sn}}</span>
              </p>
              <p>
                <span class="s-label">状态 </span>
                <span>{{item.device_status}}</span>
              </p>
              <p>
                <span class="s-label">类型 </span>
                <span>
                  <el-tag v-if="item.category==='温控'" type="danger">{{item.category}}</el-tag>
                  <el-tag v-if="item.category==='配煤' " type="info">{{item.category}}</el-tag>
                  <el-tag v-if="item.category==='配水'">{{item.category}}</el-tag>
                 </span>

              </p>
            </div>
            <img :src="image1" alt="">
          </div>
        </el-card>
      </div>
      <div class="device-item" v-if="deviceList&&deviceList.length">
        <div class="add-new-device" @click="openBindDevice('device')">
          <i class="iconfont icon-dms-add_dashed"></i>
          <p>添加新设备</p>

        </div>

      </div>


    </div>
    <div class="no-device" v-if="!loading&&deviceList.length<=0">
      <img :src="img_no_devices" alt="">
      <div class="noItem-button-group">
        <el-button type="primary" @click="openBindDevice('device')">绑定设备</el-button>
        <el-button type="primary" @click="openBindDevice('account')">绑定已有账号</el-button>
      </div>

    </div>
    <el-dialog :size='isMobile?"large":"small"' :title="dialog.method==='account'?'绑定账号':'添加设备'"
               :visible.sync="dialog.show">
      <el-form ref="dialog" :model="dialog">
        <el-form-item v-if="dialog.method==='account'" label="原平台账号">
          <el-input placeholder="services.leemma.com账号" v-model="dialog.name"></el-input>
          <span v-show="dialog.adminShow" class="input-tips">利马管理人员请登录<a href="https://services.leemma.com">https://services.leemma.com</a></span>
        </el-form-item>
        <el-form-item v-if="dialog.method==='account'" label="密码">
          <el-input type="password" placeholder="services.leemma.com密码" v-model="dialog.password"></el-input>
        </el-form-item>
        <template v-else>
          <!-- <el-form-item label="设备DTU号">
             <el-input v-model="dialog.device_sn"></el-input>
         </el-form-item> -->
          <el-form-item label="设备激活码">
            <el-input v-model="dialog.uuid"></el-input>
            <span class="input-tips">联系利马客服获取您的设备激活码 <a href="tel:18030536882">18030536882(周星)</a>  </span>
          </el-form-item>
        </template>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button v-if="dialog.method==='account'" @click="openBindDevice('device')" type="text">没有账号？绑定新设备</el-button>
        <el-button v-else @click="openBindDevice('account')" type="text">绑定已有账号</el-button>

        <el-button type="primary" @click="customerBinding">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import image1 from "../../assets/images/tempicon.svg";
  import img_no_devices from "../../assets/images/no device.svg";
  import pageHeader from "../../components/tempControl/header";
  import {mapState} from "vuex";
  import lib from "../../lib/lib";

  export default {
    name: "deviceList",
    components: {
      pageHeader
    },
    data() {
      return {
        image1,
        img_no_devices,
        deviceList: [],
        loading: true,
        dialog: {
          show: false,
          method: "device",
          name: "",
          device_sn: "",
          uuid: "",
          password: "",
          adminShow: false
        },
        typeName: {
          "温控": "5a3338e0aa22fb6a17cd77fb",
          "配水": "5a585accaa22fb4a9db5aa5a",
          "配煤": "5a585ad7aa22fb4a9db5aa5b",
        }
      };
    },
    computed: {
      ...mapState({
        userInfo: state => state.userInfo,
        isMobile: state => state.isMobile,
        deviceListType: state => state.deviceListType
      })
    },
    created() {
    },
    mounted() {
      this.loadDeviceList();
    },
    methods: {
      loadDeviceList() {
        let params = {
          customer_token: this.userInfo.token,
          page_no: 1,
          page_size: 20,
          category_id: this.deviceListType?this.typeName[this.deviceListType]:'',
          // sort_key:"",
          // sort_order:""
        };
        lib.api.loadDevice(params, data => {
          this.loading = false;
          if (data.status_code !== "SUCCEEDED") {
            this.$message.error(data.msg);
          } else {
            this.deviceList = data.payload;
            if (this.deviceList.length && !this.$route.query.sider) {
              let index = this.findTypeDevice(data.payload).index, count = this.findTypeDevice(data.payload).count;
              if (index !== "NONE" && count === 1) {
                this.intoDevice(index);
              } else if (count > 1) {

              } else {
                if (this.deviceListType) {
                  this.$message({
                    type: 'info', duration: 5000,
                    message: '您没有' + this.deviceListType + '设备'
                  });
                  this.$store.dispatch('setDeviceListType', '')
                }
              }
            }else  if (this.deviceList.length===0){
              //没设备进入时 弹出绑定设备
              this.dialog.show=true;
            }
          }
        });
      },
      findTypeDevice(list) {
        let index = "NONE", count = 0;
        list.forEach((item, i) => {
          if (item.category === this.deviceListType) {
            index = i;
            count++
          }
        });
        console.log(index)
        return {index, count};
      },
      openBindDevice(method) {
        let dialog = this.dialog;
        dialog.method = method;
        dialog.show = true;
      },
      customerBinding() {
        let params = {
          customerId: this.userInfo.id,
          customer_token: this.userInfo.token,
          method: this.dialog.method
        };
        if (params.method === "account") {
          params.name = this.dialog.name;
          params.password = this.dialog.password;
          if (params.name * 1 < 1000) {
            this.dialog.adminShow = true;
            return false;
          }
          if (params.name * 1 < 1000) {
            this.$message.error("请输入密码");
            this.dialog.show = false;
            return false;
          }
        } else if (params.method === "device") {
          // params.device_sn = this.dialog.device_sn;
          params.uuid = this.dialog.uuid;
        }
        lib.api.bindDevice(params, data => {
          if (data.status_code === "SUCCEEDED") {
            this.$message.success("操作成功");
            this.dialog.show = false;
            this.loadDeviceList();
          } else {
            this.$message.error(`${data.msg}`);
          }
        });
      },
      // 进入设备面板，并存贮设备信息
      intoDevice(index) {
        let device = this.deviceList[index];
        this.$store.dispatch("setDeviceInfo", device);
        if (device.category === "温控") {
          if (this.isMobile) {
            this.$router.push({path: "/MtempControl/realData"});
          } else {
            this.$router.push({path: "/tempControl/realData"});
          }
        } else {
          this.$router.push({path: "/allocate/realData"});
        }
      }
    }
  };
</script>

<style scoped>
  .input-tips {
    color: #0056b8;
    font-size: 12px;
  }

  .device-list {
    margin-top: 20px;
    display: flex;
    flex-wrap: wrap;
  }

  .device-item {
    width: 30%;
    max-width: 600px;
    min-width: 240px;
    margin: 10px 3% 10px 0;
    cursor: pointer;
  }

  .el-card:hover {
    box-shadow: 1px 1px 1px 1px rgba(35, 120, 220, 0.4);
  }

  .add-new-device {
    border: 2px dashed #999eae;
    height: 256px;
    color: #999eae;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }

  .add-new-device .iconfont {
    font-size: 60px;
    margin-bottom: 10px;
  }

  .device-list .device-item:nth-child(2n + 0) {
    /*margin-right: 0*/
  }

  .card-heard {
    font-size: 0.2rem;
    margin-bottom: 30px;
  }

  .device-info {
    display: flex;
    justify-content: space-between;
    display: -webkit-flex;
    height: 150px;
  }

  .device-info > div:first-child {
    display: flex;
    flex-direction: column;
    /* height: 230px; */
    justify-content: space-between;
  }

  .device-info p {
    font-size: 0.18rem;
    line-height: 0.24rem;
  }

  .device-info span {
    display: inline-block;
  }

  .device-info .s-label {
    width: 60px;
    text-align: right;
    margin-right: 20px;
    font-weight: bold;
  }

  .device-info img {
    width: 50%;
  }

  .el-button a {
    color: #fff;
  }

  .no-device {
    margin: auto;
    width: 600px;
    color: #0056b8;
  }

  .noItem-button-group {
    display: flex;
    justify-content: center;
    margin-top: 30px;
  }

  .noItem-button-group .el-button {
    width: 160px;
  }

  .dialog-footer {
    display: flex;
    justify-content: space-between;
  }

  @media (max-width: 1366px) {

    .device-item {
      width: 45%;
      margin: 10px 2%;
    }

    .device-info .s-label {
      text-align: left;
    }

    .device-info span {
      font-size: 14px;
      display: block;
      width: 40px;
    }
  }

  @media (max-width: 800px) {
    .device-list {
      justify-content: center;
    }

    .device-item {
      width: 100%;
      margin: 10px 0px;
    }

    .device-info .s-label {
      text-align: left;
    }

    .device-info span {
      font-size: 14px;
      display: block
    }

    .no-device {
      width: 90%;
    }
  }

  body {
    overflow: visible!important;
  }

</style>



// WEBPACK FOOTER //
// deviceList.vue?be626170